export default {
  // Brand and tagline
  "sri_astro_veda": "சூர்யா மீடியா",
  "footer_tagline": "ஜோதிடம் & வாஸ்து. நவீனம், தனிப்பட்டது, நம்பகமானது.",

  // Navigation
  "navigation": "வழிசெலுத்தல்",
  "home": "முகப்பு",
  "about": "எங்களைப் பற்றி",
  "contact": "தொடர்பு",
  "get_reading": "ஜோதிட வாசிப்பைப் பெற",

  // Core Services
  "core_services_footer": "முக்கிய சேவைகள்",
  "birth_chart_footer": "ஜாதகம்",
  "match_kundli_footer": "குண்டலி பொருத்தம்",
  "ascendant_footer": "லக்னம்",
  "dasha_analysis_footer": "தசா பகுப்பாய்வு",
  "nakshatra_footer": "நட்சத்திரம்",
  "numerology_footer": "எண்ணியல்",

  // Predictions
  "predictions_footer": "முன்கணிப்புகள்",
  "life_predictions_footer": "வாழ்க்கை முன்கணிப்புகள்",
  "2025_report_footer": "2025 அறிக்கை",
  "daily_horoscope_footer": "தினசரி ராசிபலன்",
  "love_report_footer": "காதல் அறிக்கை",
  "career_report_footer": "தொழில் அறிக்கை",
  "health_report_footer": "சுகாதார அறிக்கை",

  // Remedies
  "remedies_footer": "பரிகாரங்கள்",
  "lal_kitab_footer": "லால் கிதாப்",
  "mangal_dosha_footer": "மங்கள தோஷம்",
  "kalsarp_dosh_footer": "காலசர்ப தோஷம்",
  "sade_sati_footer": "சாடே சதி",
  "ask_question_footer": "கேள்வி கேளுங்கள்",
  "gemstones_footer": "ரத்தினங்கள்",

  // Support
  "support": "ஆதரவு",
  "whatsapp_support": "WhatsApp ஆதரவு",
  "available_24_7": "அரட்டை ஆதரவு",

  // Footer bottom
  "all_rights_reserved": "அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை",
  "made_with": "இதனுடன் உருவாக்கப்பட்டது",
  "in_india": "இந்தியாவில்",
  "privacy_policy": "தனியுரிமைக் கொள்கை",
  "terms_of_service": "சேவை விதிமுறைகள்",
  "disclaimer": "பொறுப்புத்துறப்பு",
  "cancellation_policy": "ரத்துசெய் கொள்கை",
  "shipping_policy": "அனுப்பல் கொள்கை"
}
